import '../css/main.css'
import './style.css'
import axios from 'axios';
import { useState, useEffect } from 'react';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import RecoverPasswordModal from './recover-password.js';
import { useData } from '../../contexts/DataContext.js';
import BasicPopUp from '../PopUp/basic-popup.js';


const Login=function() {

    const location = useLocation();
    const currentPath = location.pathname;
    const data=useData()
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [form,setForm]=useState({})
    const [message,setMessage]=useState('')
    const [showRecoverPasswordDialog,setShowRecoverPasswordDialog]=useState(false)
    const [success,setSuccess] = useState(false)
    const [recoverPasswordStatus,setRecoverPasswordStatus]=useState('code_not_sent')
    const [showPasswordRecoveredOk,setShowPasswordRecoveredOk]=useState(false)
    const [inactiveMicrocredits,setInactiveMicrocredits]=useState([])
    const [showInactiveList,setShowInactiveList]=useState(false)
    const [paymentRequired,setPaymentRequired]=useState(false)
    const navigate=useNavigate()

    const handleKeyPress = (event) => {

        if (event.key == 'Enter') {
          handleLogin();
        }

    };

    useEffect(()=>{
        if(currentPath.includes('/test')){
            setPassword('secret')
            setEmail('test@visum.co.mz')
        }
    },[])


    const handleLogin = async () => {
         toast.remove()

         if(!email || !password){
            toast.remove()
            toast.error('Preencha todos os campos!')
            return
         }

         if(!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim()))){
          toast.error('Email inválido')
          setLoading(false)
          return
        }

         setLoading(true)

          try {
             const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/login`, {
               email,
               password
             });

              setLoading(false)
              toast.remove()

              localStorage.setItem('token', response.data.token);
              localStorage.setItem('refresh-token', response.data.refreshToken);

              if(response.data.payment_required){
                 setInactiveMicrocredits(response.data.inactive_microcredits || [])
                 setPaymentRequired(true)
                 setShowInactiveList(true)
                 toast.error('Pagamento necessário. Alguns microcréditos estão inativos.')
                 return
              }

              setPaymentRequired(false)

              if(response.data.inactive_microcredits && response.data.inactive_microcredits.length>0){
                  setInactiveMicrocredits(response.data.inactive_microcredits)
                  setShowInactiveList(true)
                  toast('Alguns microcréditos estão inativos e requerem pagamento.', { icon: '⚠️' })
              } else {
                  toast.success('Autenticado com sucesso!')
                  window.location.href="/";
              }

         } catch (e) {
          let msg="Acorreu um erro, tente novamente"
          console.log(e)
          setLoading(false)

          if(e.response){
            if(e.response.status==404){
                msg="Usuário não encotrado"
            }
            if(e.response.status==401){
              msg="Senha incorreta"
            }
            if(e.response.status==423){
              msg="Usuário não associado a microcrédito activa"
          }
            if(e.response.status==400){
                msg="Dados inválidos"
            }
            if(e.response.status==500){
                msg="Erro, inesperado. Contacte seu administrador"
            }

          }else if(e.code=='ERR_NETWORK'){
                msg="Verfique sua internet e tente novamente"
          }

          toast.error(msg)
          setLoading(false)
        }
    };



    function recoverPasswordSubmit(){
        if(recoverPasswordStatus=="code_not_sent"){
                    SendCode()
        }
        if(recoverPasswordStatus=="code_sent"){
                  VerifyCode()
        }
    }


    async function VerifyCode(){

        setMessage('')
        setLoading(true)

        try{

            let response=await data.makeRequest({method:'post',url:`api/verify-code`,data:{...form,action:'recover_password'}, error: ``},0);
            localStorage.setItem('token',response.token)
            localStorage.setItem('refresh-token',response.refreshToken)
            setShowRecoverPasswordDialog(false)
            setShowPasswordRecoveredOk(true)

        }catch(e){
            setLoading(false)
            let msg="Erro, inesperado. Contacte seu administrador"

            if(e.response){
              if(e.response.status==400){
                  msg='Código inválido ou usado'
              }
              if(e.response.status==500){
                  msg="Erro, inesperado. Contacte seu administrador"
              }

            }else if(e.code=='ERR_NETWORK'){
                  msg="Verfique sua internet e tente novamente"
            }
            setMessage(msg)

        }

    }
    


   async function SendCode(){

    setMessage('')

    if(!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim()))){
       setMessage('E-mail inválido')
       return
    }

    setLoading(true)
    setForm({...form,code:''})

    try{
      await data.makeRequest({method:'post',url:`api/send-verification-code`,data:{email:form.email,action:'recover_password'}, error: ``},0);
      setLoading(false)
      if(showRecoverPasswordDialog){
         setRecoverPasswordStatus('code_sent')
      }
    }catch(e){

       setLoading(false)
       let msg="Erro, inesperado. Contacte seu administrador"

       if(e.response){
        if(e.response.status==404){
          msg='Usuário não encontrado!'
        }
        if(e.response.status==400){
            msg='Código inválido ou usado'
        }
        if(e.response.status==500){
            msg="Erro, inesperado. Contacte seu administrador"
        }

      }else if(e.code=='ERR_NETWORK'){
            msg="Verfique sua internet e tente novamente"
      }
      setMessage(msg)
    }
  }


  useEffect(()=>{

    if(new URLSearchParams(window.location.search).get('recover-password')){
      setShowRecoverPasswordDialog(true)
      return
    }

  },[])

  return (
    <>
    
 <BasicPopUp  
    show={showPasswordRecoveredOk} title={'Senha alterada'}
    btnConfirm={{text:'Entrar',onClick:()=>{
          setShowPasswordRecoveredOk(false)
          window.location.href="/"
    }}}
    link={{text:'',onClick:()=>{}}}
    message={'Sua senha foi actualizada com sucesso. A nova senha foi envida para seu email'}         
  />
     
    <RecoverPasswordModal status={recoverPasswordStatus} setStatus={setRecoverPasswordStatus} success={success} resendCode={SendCode}  message={message} setMessage={setMessage} setForm={setForm} loading={loading} SubmitForm={recoverPasswordSubmit} form={form} setShow={setShowRecoverPasswordDialog} show={showRecoverPasswordDialog}/>

      <main  className={`login-container ${loading && 'loading'}`}>
       
       <div className="msg-error"></div>

       {showInactiveList && inactiveMicrocredits.length>0 && (
         <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm animate-fadeIn">
           <div className="relative w-full max-w-lg bg-white rounded-2xl shadow-2xl transform transition-all" style={{ animation: 'slideUp 0.4s ease-out' }}>
             <div className="absolute -top-4 -right-4 w-12 h-12 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full flex items-center justify-center shadow-lg">
               <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                 <circle cx="12" cy="12" r="10"/>
                 <line x1="12" y1="8" x2="12" y2="12"/>
                 <line x1="12" y1="16" x2="12.01" y2="16"/>
               </svg>
             </div>
             <div className="p-6 pb-4 border-b border-gray-100">
               <h3 className="text-2xl font-bold text-gray-800">Pagamento Necessário</h3>
               <p className="text-sm text-gray-500 mt-1">Os seguintes microcréditos estão inativos. Regularize para continuar.</p>
             </div>
              <div className="px-6 py-4 max-h-64 overflow-y-auto">
                <ul className="space-y-3">
                  {inactiveMicrocredits.map((mc, idx) => (
                    <li key={mc.id || idx} className="group transition-all duration-200">
                      <div className="flex items-start gap-3 p-3 rounded-xl bg-gradient-to-r from-gray-50 to-gray-100/50 hover:from-yellow-50/80 hover:to-orange-50/80 border border-gray-200/50">
                        <div className="w-8 h-8 bg-gradient-to-br from-yellow-400/20 to-orange-500/20 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#D97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                            <polyline points="22 4 12 14.14 9 11.14 5 15.14 3 13.14 9 7.14z"/>
                          </svg>
                        </div>
                        <div className="flex-1">
                          <strong className="text-gray-800 font-semibold block">{mc.name}</strong>
                          <span className="text-xs text-gray-500">{mc.location}</span>
                          <span className="inline-block text-xs bg-yellow-100 text-yellow-800 px-2 py-0.5 rounded mt-1">Inactivo - Pagamento necessário</span>
                        </div>
                       <div>
                         <button
                          onClick={() => { setShowInactiveList(false); navigate(`/plan-checkout?plan=${mc.plan}&period=monthly&microcredit_id=${mc.id}`); }}
                          className="flex-shrink-0 mt-0.5 px-3 py-1.5 text-xs font-medium text-white bg-gradient-to-r from-blue-500 to-indigo-600 rounded-lg hover:from-blue-600 hover:to-indigo-700 transition"
                        >
                          Pagar
                        </button>
                       </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="p-6 pt-4 border-t border-gray-100 flex justify-end gap-3 bg-gray-50/50 rounded-b-2xl">
                <button onClick={()=>setShowInactiveList(false)} className="px-5 py-2 text-sm font-medium text-gray-600 bg-white border border-gray-300 rounded-lg hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 transition">Fechar</button>
                {!paymentRequired && (
                  <button onClick={()=>{ setShowInactiveList(false); window.location.href="/"; }} className="px-5 py-2 text-sm font-medium text-white bg-gradient-to-r from-yellow-500 to-orange-500 rounded-lg hover:from-yellow-600 hover:to-orange-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-400 transition">Entrar assim mesmo</button>
                )}
              </div>
           </div>
         </div>
        )}
              
        <div className="center-div">
                
                 <div className="login-form">
                  
                  <div className="logo-c">
                        <h1 className="underline cursor-pointer" onClick={()=>{
                             window.location.href="/"
                        }}>VLMS</h1>
                  </div>
                  
                  <h2>Login</h2> 

                  <div className="div-input">
                          <svg xmlns="http://www.w3.org/2000/svg" height="22" viewBox="0 -960 960 960" ><path fill="#D9D9D9" d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z"/></svg>
                          <input  onKeyPress={handleKeyPress} value={email} onChange={(e) => setEmail(e.target.value)} className="username" type="text" placeholder="Email"/>
                  </div>

                  <div className="div-input">
                          <svg xmlns="http://www.w3.org/2000/svg" height="22" viewBox="0 -960 960 960"><path fill="#D9D9D9" d="M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h40v-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm0-80h480v-400H240v400Zm240-120q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280ZM360-640h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80ZM240-160v-400 400Z"/></svg>
                          <input  onKeyPress={handleKeyPress} value={password} onChange={(e) => setPassword(e.target.value)} className="password" type="password" placeholder="Senha"/>
                  </div>

                  <div onClick={()=>{
                       setShowRecoverPasswordDialog(true)
                  }} className="forgot-password text-gray-400 underline text-[0.9rem]">Recuperar senha</div>

                  <div className="div_btn">
                     <button onClick={handleLogin}>Entrar</button>
                     <span className="loader"></span>
                  </div>
                </div>

            <div className="text-container">
                <div className="top-content">
                  <span className="welcome-text">Bem vindo!</span> 
                  <div className="copy">VLMS &copy; 2025</div>
                </div>
            </div>

      </div>
       <div className="footer"><span><Link to={"/terms"}>Termos</Link></span> | <span><Link to={"/privacy-politics"}>Politicas</Link></span></div>
    </main>
    </>
  );
}

export default  Login
